import React, { useMemo } from 'react';
import { Container, Row, Card, Col } from 'react-bootstrap';
import { HelpOutline } from '@material-ui/icons';
import Faq from "react-faq-component";
import { useCompany } from 'models';
import FaqFile from "./faq.json";

import './style.css';


export default function () {
  const { company } = useCompany();
  const data = useMemo(() => {
    return {
      rows: clearJson(FaqFile).map((item) => {
        return {
          title: item.title,
          content: `
        <div class="card-body text-left">
        <p>
          ${item.body.map((b) => {
            if (typeof b === 'object') {
              return `<${b.type}>
              ${b.list.map(li => {
                return `<li>${li}</li>`;
              }).join("")}
            </${b.type}>`
            }
            return `${b.replaceAll("</t>", "<label class=\"tab\"></label>")}`;
          }).join('</br>')}
        </p>
        </div>
        `
        };
      })
    }
  }, [FaqFile])

  function replaceImagePath(match, path) {
    return '<img width='+500+' src='+require(`images/faq/${path}`)+' />'
  }

  function clearJson(json) {
    let string = JSON.stringify(json)
    string = string.replace(/\$\[(.*?)\]/g, replaceImagePath)
    return JSON.parse(string)
  }

  return (<>
    <Container>
      <Row className="mt-4">
        <HelpOutline className="icon-title" />
        <h5 className="title-dashboard">Perguntas Frequentes - Elite</h5>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded text-center m-2 p-4 col-12">        
          <Faq data={data} />
          <Row>
            <Col md="12" className="mt-3">
              <p>
                Para outras dúvidas: <a href="mailto:elitepass@scansource.com">elitepass@scansource.com</a>
              </p>
            </Col>
          </Row>
        </Card.Body>
      </Row>
    </Container>
  </>);
};
